module.exports = __webpack_public_path__ + "img/Game Collection Mini.a631114e.webp";